import { INavpanelAction, NAVPANEL_ACTION_TYPE, ICardExtended, SUBSCRIPTION_STATUS } from './../../models/card';
import { FirebaseAuthService } from './firebase-auth.service';
import { UtilityFunctionsService } from 'src/app/shared/providers/utility-functions.service';
import { ICollaborator } from './../../models/collaboration';
import { UploadFileService } from './upload-file.service';
import { SettingsService } from './settings.service';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { DEFAULT_USER_COLLECTION_ID, DtoICard, DtoICollection, ICardCollection, ILikedUserData } from 'src/app/models/collection';
import { MockDataService } from 'src/app/shared/providers/mock-data.service';
import { Injectable } from '@angular/core';
import { CARD_PURCHASE_STATUS, ICard, ModelCardRendered, ModelCardRenderedSelection } from 'src/app/models/card';
import { CardsService } from './cards.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { IGroupedCard } from 'src/app/models/groupedCard';
import { PurchaseService } from './purchase.service';
import { ViewsUpdateService, RefreshMode } from './views-update.service';
import { sortCardsByDate } from 'src/app/shared/pipes/sort-by-date.pipe';
import { isAdvancedSearchSessionCollectionId } from 'src/app/models/advanced-search-session-collection';
const CORRECT_APP_POSTER = environment.type === 'web' ? 'cardPosterWeb' : 'cardPosterMobile';
const CORRECT_APP_CONTENT = environment.type === 'web' ? 'cardContentWeb' : 'cardContentMobile';

interface IReviewCardMeta {
  reviewId?: string;
  reviewCreatedAt?: string;
  rejectionViewed?: boolean;
  rejectionViewedAt?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class UserDataService {

    public isUserAuthenticated: boolean;
    public notLoggedSubscription: Subscription;

    // used for making transition between edit-collection/library more seamless
    public librarySavedScrollPosition: number;

    private isNavbarMainActionDisabled: boolean = false;

    public userReviewPublishRejectModels: ICardExtended[] = [];

    public userDraftCollections: ICardCollection[] = [];

    // public userNotInCollectionCards: ModelCardRendered[] = [];
    // public defaultUserCollection: ICardCollection = this.mockDataService.generateNotInCollectionGalleryBasedOnMock(this.mockDataService.galleryNotInCollection, '_1628_2500k.mp4');

    // NOT VERY CLEAN APPROACH, THINK ABOUT THAT LATER ON;
    public userHomeFeed: ICardCollection[];


    public savedCards: ICard[] = [];
    public savedCardsSubject: Subject<ICard[]> = new Subject();

    public savedCollections: ICardCollection[] = [];
    public savedCollectionsSubject: Subject<ICardCollection[]> = new Subject();

    public uploadedCards: ICard[] = [];

    public toDeleteCardBuffer: ModelCardRenderedSelection[] = [];
    public deletedCards: ModelCardRenderedSelection[] = [];
    public deletedCollections: ICardCollection[] = [];

    public dragOver: boolean;

    // public userPurchasedCollections: ICardCollection[] = [];
    public userPurchasedCards: ICard[] = [];
    public userPurchasedCollections: ICardCollection[] = [];

    public userAllModelsCollection: ICardCollection;

    public uploadedCardRecieved: Subject<ICard[]> = new Subject();

    public initilizeUserDataFinished: Subject<boolean> = new Subject();

    public userCollectionSnapshot: ICardCollection;

    public isRecievedModelsRespFromBackend: boolean;
    public isRecievedDraftCollectionsRespFromBackend: boolean;
    public recievingModelsRespBackendProgress: number = 1;

    // NEW COLLECTION
    public newCollectionName: string;
    uploadServiceSubscription: Subscription;
    private reviewMetaByModelId = new Map<string, IReviewCardMeta>();


    private temporaryPurchaedCardsMock = [
      '0f751bb3a3024ff19aad51cfb0562166',
      '257500990e514ffaa09cf9735f758026',
      '9debbf19477f4a0ba0eff682cf2677ee',
      'cdf1218c6bc54f068ab86e8f56f658a2',
      'd50aa93fc56347fb8df2b8a206a740da',
      'e97b94d9720846428ce453ddc535787d',
      'ubiseaifa_LOD01675749555738'
    ]
  isLogoutHappened: boolean;

  public get allUserCards() {
    return [...this.uploadedCards, ...this.savedCards, ...this.userPurchasedCards, ]
  }

  public get isUserSubscribed() {
    return this.firebaseAuth.currentUser?.subscriptionStatus === SUBSCRIPTION_STATUS.SUBSCRIBER;
  }

  public get userSubscriptionStatus() {
    return this.firebaseAuth.currentUser?.subscriptionStatus;
  }

  public get isTryFreeEnabled() {
    return this.firebaseAuth.currentUser?.subscriptionStatus === SUBSCRIPTION_STATUS.GUEST;
  }

  public get isFreeUploadLimitReached() {
    return  this.firebaseAuth.currentUser?.uploadsNumber >= this.firebaseAuth.currentUser?.uploadNumberLimit
  }

  public get publishedUserCards() {
    return this.userReviewPublishRejectModels.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.PUBLISHED);
  }

  public get rejectedUserCards() {
    return this.userReviewPublishRejectModels.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED);
  }

  public get inReviewUserCards() {
    return this.userReviewPublishRejectModels.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.IN_REVIEW);
  }

  public get reviewAndPublishedCards() {
    return this.userReviewPublishRejectModels
      .filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.IN_REVIEW || card.purchaseStatus === CARD_PURCHASE_STATUS.PUBLISHED || card.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED);
  }

  public isCardRejectedAndUnviewed(card?: ICard | null): boolean {
    if (!card || card.purchaseStatus !== CARD_PURCHASE_STATUS.REJECTED) {
      return false;
    }

    return !Boolean(this.getReviewMeta(card.id)?.rejectionViewed);
  }

  // public get allUserDraftCollections() {
  //   return this.userDraftCollections.forEach((col) =>{
  //     const modelIds = col.collectionCards.map(card => card.id);
  //     this.allUserCards.filter(card => modelIds.includes(card.id))
  //   })

  //   return this.userDraftCollections.filter(col => col.collectionId !== DEFAULT_USER_COLLECTION_ID);
  // }

  public get allUserDraftCollections() {
    // Draft collections often arrive before likes/uploads/purchases finish hydrating.
    // Keep raw collection cards as a fallback so direct edit-collection reloads do not
    // flash partial results or an empty gallery while canonical user-card state catches up.
    return this.userDraftCollections.map(collection => ({
      ...collection,
      collectionCards: isAdvancedSearchSessionCollectionId(collection.collectionId)
        ? collection.collectionCards
        : this.getFilteredModelsFromAllUserCards(collection.collectionCards)
    }));
  }



  // eslint-disable-next-line max-len
  constructor(public mockDataService: MockDataService, public firebaseAuth: FirebaseAuthService, public settingService: SettingsService,
     public uploadService: UploadFileService, public utilityFunctionsService: UtilityFunctionsService,
     public cardService: CardsService, public purchaseService: PurchaseService, private _snackBar: MatSnackBar,
     private viewsUpdateService: ViewsUpdateService,
     ) {

      this.notLoggedSubscription = this.firebaseAuth.notLoggedUserSubscription.subscribe(() => {
        this.isUserAuthenticated = false;
        this.isLogoutHappened = true;
        // Reset views update service on logout
        this.viewsUpdateService.reset();
      })

    this.incrementProgress();
    this.firebaseAuth.firebaseUser.subscribe((user) => {
      this.isUserAuthenticated = false;
      if(user) {
        this.isUserAuthenticated = true;
        if(this.isLogoutHappened) {
          this.cardService.collectionFeedInit();
        }
        this.updateSavedModelsAndCollectionsDoneForAnonymous();
        this.initializeUserData();
        this.initUserPurchases();
      }
    });
    this.subscribeToLatestUploadedModel();
    this.subscribeToViewsRefresh();

  }

  private updateSavedModelsAndCollectionsDoneForAnonymous() {
    this.savedCards.forEach(card => {
      this.cardService.setUserLike(card).catch(error => {
        // On error remove the card if already added
        console.log('Error saving card, removing from liked', error);
        const index = this.savedCards.findIndex(c => c.id === card.id);
        if (index !== -1) {
          this.savedCards.splice(index, 1);
        }
      });
    });
    this.savedCollections.forEach(collection => {
      this.cardService.setUserLike(collection).catch(error => {
        // On error remove the collection if already added
        const index = this.savedCollections.findIndex(c => c.collectionId === collection.collectionId);
        if (index !== -1) {
          this.savedCollections.splice(index, 1);
        }
      });
    });
  }

  // REFACTORED

  private async initializeUserData() {
    this.getAllUserLikes(); // Assuming this is an async method without a need to await its result

    await Promise.all([
      this.fetchUserUploadedModels(),
      this.fetchUserDraftCollections(),
    ]);

    this.initilizeUserDataFinished.next(true);
  }

  private async fetchUserUploadedModels() {
    try {
      const uid = await this.firebaseAuth.getUserUid();

      const [models, reviews] = await Promise.all([
        this.cardService.getUserUploadedModels(uid),
        this.cardService.getUserAllReviews(uid)
      ]);

      this.reviewMetaByModelId.clear();
      models.forEach((model: ICardExtended) => {
        if (!model?.id) return;

        this.upsertReviewMeta(model.id, {
          reviewCreatedAt: model.reviewCreatedAt || undefined,
          reviewId: model.reviewId || undefined,
          rejectionViewed: model.rejectionViewed,
          rejectionViewedAt: model.rejectionViewedAt ?? undefined,
        });
      });

      if (Array.isArray(reviews)) {
        reviews.forEach((review: DtoICard) => {
          if (!review || !review.model_id) return;

          this.upsertReviewMeta(review.model_id, {
            reviewCreatedAt: review.review_created_at || '',
            reviewId: review.review_id || '',
            rejectionViewed: Boolean(review.rejection_viewed),
            rejectionViewedAt: review.rejection_viewed_at ?? null,
          });
        });
      }

      models.forEach((model: ICardExtended) => {
        const reviewInfo = this.getReviewMeta(model.id);
        if (!reviewInfo) return;

        model.reviewCreatedAt = reviewInfo.reviewCreatedAt || model.reviewCreatedAt || '';
      });

      this.isRecievedModelsRespFromBackend = true;
      this.processUploadedModels(models);
    } catch (err) {
      console.log(err);
      this.isRecievedModelsRespFromBackend = true;
      this.userReviewPublishRejectModels = [];
      this.reviewMetaByModelId.clear();
    }
  }

  public async refreshUploadedModelsForOwnedModeratedCard(card?: ICard | null): Promise<void> {
    if (!card?.id || !card?.cardAuthor || !this.firebaseAuth.currentUser?.uid) {
      return;
    }

    // WORKAROUND:
    // After admin approve/reject of their own model, local uploaded/review state can stay stale
    // until a full page reload. Re-run the existing uploaded models fetch only for owned cards.
    if (card.cardAuthor !== this.firebaseAuth.currentUser.uid) {
      return;
    }

    await this.fetchUserUploadedModels();
  }

  private processUploadedModels(models: ModelCardRendered[]) {
    // Validate models before assignment
    if (!Array.isArray(models)) {
      console.error('[UserDataService] processUploadedModels: Invalid models array');
      models = [];
    }

    // Check for cards with missing poster URLs (summary only)
    const cardsWithoutPosters = models.filter(card =>
      !card.cardPosterMobile || card.cardPosterMobile === ''
    );

    if (cardsWithoutPosters.length > 0) {
      console.warn(`[UserDataService] ${cardsWithoutPosters.length} cards without posters. Check debug overlay on cards.`);
    }

    this.uploadedCards = sortCardsByDate(models, 'modifiedDate');
    console.log('this.uploadedCards', this.uploadedCards);

    if (environment.type === 'web') {
      this.filterWebCards();
    }

    this.syncReviewCardsFromUploadedModels();

    this.uploadedCardRecieved.next(this.uploadedCards);
  }

  private filterWebCards() {
    const originalCount = this.uploadedCards.length;

    // Create a Set for faster lookup - O(1) instead of O(n)
    const uploadingIds = new Set(this.uploadService.uploadModels.map(model => model.id));

    // Filter in one pass with proper validation
    const filtered = this.uploadedCards.filter(card => {
      // Validate card
      if (!card || !card.id) {
        return false;
      }

      // Check if has web content and not currently uploading
      const hasWebContent = card.cardContentWeb && card.cardContentWeb !== '';
      const isNotUploading = !uploadingIds.has(card.id);

      return hasWebContent && isNotUploading;
    });

    // Assign filtered array atomically to avoid race condition
    this.uploadedCards = filtered;

    const removed = originalCount - this.uploadedCards.length;
    if (removed > 0) {
      console.log(`[UserDataService] filterWebCards: ${removed} cards filtered out (no web content or uploading)`);
    }
  }

  private async fetchUserDraftCollections() {
    try {
      const col = await this.cardService.getUserDraftCollections();
      console.log('Draft User Collection Recieved', col);
      this.isRecievedDraftCollectionsRespFromBackend = true;
      this.userDraftCollections = col;
    } catch (err) {
      this.isRecievedDraftCollectionsRespFromBackend = true;
      console.log(err);
    }
  }

  private syncReviewCardsFromUploadedModels(): void {
    const reviewStatuses = new Set<CARD_PURCHASE_STATUS>([
      CARD_PURCHASE_STATUS.IN_REVIEW,
      CARD_PURCHASE_STATUS.PUBLISHED,
      CARD_PURCHASE_STATUS.REJECTED,
      CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT,
    ]);

    const filteredCards = this.uploadedCards
      .filter((card) => reviewStatuses.has(card.purchaseStatus))
      .map((card) => ({ ...card }));

    this.userReviewPublishRejectModels = sortCardsByDate(filteredCards, 'reviewCreatedAt');
  }

  subscribeToLatestUploadedModel() {
    this.uploadServiceSubscription = this.uploadService.latestUploadedModelSubscription.subscribe(async item => {
      console.log('latestUploadedModelSubscription', item);
      try {
        const newCard = await this.processUploadedModel(item);
        this.addCardToCollections(newCard, item.linkedCollectionId);
      } catch (error) {
        console.error(error);
      }
    });
  }

  /**
   * Subscribes to views refresh requests from CardsService.
   * Triggered on app activation (appStateChange).
   */
  private subscribeToViewsRefresh(): void {
    this.cardService.onViewsRefreshRequested.subscribe(async () => {
      // Only refresh if user data has been initialized
      if (!this.isRecievedModelsRespFromBackend || !this.isRecievedDraftCollectionsRespFromBackend) {
        console.log('[UserDataService] Skipping views refresh - data not yet initialized');
        return;
      }

      const result = await this.viewsUpdateService.refreshOnAppActivation(
        RefreshMode.VIEWS_ONLY,
        this.uploadedCards,
        this.userDraftCollections
      );

      if (result && (result.modelsUpdated.length > 0 || result.collectionsUpdated.length > 0)) {
        // Notify UI about changes - trigger existing subjects to refresh views in components
        this.uploadedCardRecieved.next(this.uploadedCards);
      }
    });
  }

  async processUploadedModel(item: IGroupedCard) {
    const newMockCardName = this.generateMockCardName(this.uploadService.uploadModels.length);
    const newCard = this.mockDataService.generateModelCardRenderedMocksBasedOnImgUrl([newMockCardName], '_1628_2500k.mp4')[0];
    newCard.cardSharingId = item.details
    this.assignCardProperties(newCard, item);

    // Attempt to set the card model link
    try {
      // Assuming getDownloadUrlRef is an async function
      // newCard.cardModelLink = await this.firebaseAuth.getDownloadUrlRef(item.uploadStatus.uploadFileRef);
    } catch (error) {
      throw new Error('Failed to get card model link');
    }

    return newCard;
  }

  generateMockCardName(uploadFileIndex: number) {
    const fileIndexFormatted = uploadFileIndex > 9 ? `${uploadFileIndex}` : `0${uploadFileIndex}`;
    return `${this.mockDataService.genericMockCardNameBasis}${fileIndexFormatted}/${fileIndexFormatted}_poster.webp`;
  }

  assignCardProperties(newCard: ICard, item: IGroupedCard) {
    Object.assign(newCard, {
      cardTitle: item.title,
      id: item.id,
      cardAuthor: this.firebaseAuth.currentUser.uid,
      cardPrice: undefined,
      cardCategory: undefined,
      parentCollectionId: item.linkedCollectionId,
      cardPosterMobile: item.previewImageMobile,
      cardContentMobile: item.previewVideoMobile,
      cardPosterWeb: item.previewImageWeb,
      cardContentWeb: item.previewVideoWeb,
      purchaseStatus: CARD_PURCHASE_STATUS.UPLOADED
    });
  }

  addCardToCollections(newCard: any, linkedCollectionId?: string) {
    if (linkedCollectionId) {
      const collectionForUploadedCard = this.userDraftCollections.find(col => col.collectionId === linkedCollectionId);
      if (!collectionForUploadedCard.collectionCards.find(card => card.id === newCard.id)) {
        collectionForUploadedCard.collectionCards.unshift(newCard);
        this.uploadedCards.unshift(newCard);
        // this.cardService.updateCollectionPostRequest(collectionForUploadedCard);
      } else {
        console.error('Card already exists in collection');
      }
    } else {
      if (!this.uploadedCards.find(card => card.id === newCard.id)) {
        this.uploadedCards.unshift(newCard);
      } else {
        console.error('Card already exists in uploaded cards');
      }
    }
  }


  private getFilteredModelsFromAllUserCards(collectionCards: ModelCardRenderedSelection[]) {
    const allUserCardsById = new Map(this.allUserCards.map(card => [card.id, card]));
    const mergedCards = collectionCards.map((collectionCard) => {
      // Keep canonical card from allUserCards when available,
      // but do not drop cards that are currently missing there
      // (e.g. freshly created AI collection cards in debug flow).
      return allUserCardsById.get(collectionCard.id) || collectionCard;
    });

    return mergedCards.filter(card => card != null);
  }

  public createUserCollection(basicEmptyMock: ICardCollection): void {
    this.userDraftCollections.unshift(basicEmptyMock);
  }

  public updateUserCollectionData(oldId: string, newId: string, shareId: string): void {
    const index = this.userDraftCollections.findIndex(col => col.collectionId === oldId);
    if (index >= 0) {
      this.userDraftCollections[index].collectionId = newId;
      this.userDraftCollections[index].collectionSharingId = shareId;
    }
  }

  public updateUserCollectionInUserDrafCollections(collection: ICardCollection): void {
    const index = this.userDraftCollections.findIndex(col => col.collectionId === collection.collectionId);
    if (index < 0) return;
    const existing = this.userDraftCollections[index];

    // Compare models arrays for same length and order of ids.
    const areModelsEqual = (a: ModelCardRenderedSelection[], b: ModelCardRenderedSelection[]): boolean => {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i].id !== b[i].id) return false;
        }
        return true;
    };

    const modelsEqual = areModelsEqual(existing.collectionCards, collection.collectionCards);
    const descriptionEqual = existing.collectionDescription === collection.collectionDescription;

    // If both models and description are equal, update in place; otherwise, reposition to beginning.
    if (modelsEqual && descriptionEqual) {
        this.userDraftCollections[index] = collection;
    } else {
        this.userDraftCollections.splice(index, 1);
        this.userDraftCollections.unshift(collection);
    }
}

  public removeUnlikedModelFromAllDraftCollections(modelId: string): void {
    this.userDraftCollections.forEach(col => {
      col.collectionCards = col.collectionCards.filter(card => card.id !== modelId);
    })
  }

  async getAllUserLikes(): Promise<void> {
    const [feed, likesResponse] = await Promise.all([
      this.cardService.getCollectionFeed(),
      this.cardService.getAllUserLikes()
    ]);

    this.userHomeFeed = feed;
    // Handle collection likes if they exist

    if (likesResponse.liked_collections) {
      likesResponse.liked_collections.forEach(collectionData => {
        // const collectionId = collectionData.collectionId;
        // const collection = this.cardService.getCollectionFromHomeFeedById(collectionId);
        // if (collection) {
          this.addToSavedCollections(collectionData, false, false);
        // }
      });
    }
    // Handle model likes if they exist
    if (likesResponse.liked_models) {
      likesResponse.liked_models.forEach(modelData => {
        this.addToSavedCards(modelData, false);
      });
    }

    this.savedCards = sortCardsByDate(this.savedCards, 'modifiedDate');
  }

  public async helperRemoveAllLikedModels() {
    const response: ILikedUserData = await this.cardService.getAllUserLikes();
    if (response.liked_models) {
      response.liked_models.forEach((card) => {
        this.cardService.removeUserLike(card);
      });
    }
  }

  async initRealLikedModels() {
    // WORKS FOR 3 COLLECTIONS;
    const homeCollections = await this.cardService.getCollectionFeed();
    const purchasedCardsRaw: any = await this.purchaseService.getListOfUserPurchasedModels();
    const purchasedCardsList: string[] = purchasedCardsRaw.model_ids.map((id: any) => id);
    console.log('purchasedCardsList', purchasedCardsList)
    const likesForFirstCol = this.getUniqueRandomNumbers(homeCollections[0].collectionCards.length - 1, this.getUniqueRandomNumbers(5, 1)[0]);
    const likesForSecondCol = this.getUniqueRandomNumbers(homeCollections[1].collectionCards.length - 1, this.getUniqueRandomNumbers(5, 1)[0]);
    const likesForThirdCol = this.getUniqueRandomNumbers(homeCollections[2].collectionCards.length - 1, this.getUniqueRandomNumbers(5, 1)[0]);
    likesForFirstCol.forEach(likeIndex => {
      const isPurchased = purchasedCardsList.includes(homeCollections[0].collectionCards[likeIndex].id);
      if(!isPurchased) this.addToSavedCards(homeCollections[0].collectionCards[likeIndex])
    });
    likesForSecondCol.forEach(likeIndex => {
      const isPurchased = purchasedCardsList.includes(homeCollections[1].collectionCards[likeIndex].id);
      if(!isPurchased) this.addToSavedCards(homeCollections[1].collectionCards[likeIndex])
    });
    likesForThirdCol.forEach(likeIndex => {
      const isPurchased = purchasedCardsList.includes(homeCollections[2].collectionCards[likeIndex].id);
      if(!isPurchased) this.addToSavedCards(homeCollections[2].collectionCards[likeIndex])
    });

    const randomHomeCollectionToSave = this.getUniqueRandomNumbers(homeCollections.length - 1, 1)[0];
    homeCollections[randomHomeCollectionToSave] = this.updateCardsToPurchasedInCollection(homeCollections[randomHomeCollectionToSave], purchasedCardsList);
    this.savedCollections.push(homeCollections[randomHomeCollectionToSave]);
  }
  updateCardsToPurchasedInCollection(col: ICardCollection, purchasedListId: string[]): ICardCollection {
    col.collectionCards.forEach(card => {
      const isPurchased = purchasedListId.includes(card.id);
      if(isPurchased) card.purchaseStatus = CARD_PURCHASE_STATUS.PURCHASED;
    });
    return col
  }

  async initUserPurchases() {
    const homeCollections = await this.cardService.getCollectionFeed();
    const purchasedCardsRaw: any = await this.purchaseService.getListOfUserPurchasedModels();
    const purchasedCardsList: string[] = purchasedCardsRaw?.model_ids?.map((id: any) => id);

    homeCollections?.forEach(collection => {
      collection?.collectionCards?.forEach(card => {
        const isPurchased = purchasedCardsList?.includes(card.id);
        if(isPurchased) this.purchaseCards([card], collection)
      })
    })

    this.userPurchasedCards = sortCardsByDate(this.userPurchasedCards, 'modifiedDate');
  }

  private getUniqueRandomNumbers(max, count): number[] {
    const result = [];
    for (let i = 0; i < count; i++) {
      let randomNum = Math.floor(Math.random() * (max + 1));
      while (result.includes(randomNum)) {
        randomNum = Math.floor(Math.random() * (max + 1));
      }
      result.push(randomNum);
    }
    return result;
  }

  private filterCollectionForPurchasedCards(collectionsToFilter: ICardCollection[]): ICard[] {
    const cards = []
    collectionsToFilter.forEach(draftCol => {
      const purchasedCards = draftCol.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED)
      if(purchasedCards) cards.push(...purchasedCards)
    })
    return cards
  }

  public getIsNavbarMainActionDisabled(): boolean {
    return this.isNavbarMainActionDisabled;
  }

  public changeStateIsNavbarMainActionDisabledTo(isDisabled: boolean): void {
    this.isNavbarMainActionDisabled = isDisabled;
  }

  public isCardExitsInSaved(cardToCheck: ICard): boolean {
    const cardIndex = this.savedCards.findIndex((current: ICard)=> {
      return current.cardContentMobile === cardToCheck?.cardContentMobile && current.cardTitle === cardToCheck?.cardTitle;
    })
    return cardIndex >= 0;
  }

  public isCardExitsInSavedById(cardId: string): boolean {
    const cardIndex = this.savedCards.findIndex((current: ICard)=> {
      return current.id === cardId
    })
    return cardIndex >= 0;
  }

  public getSavedCards(): ICard[] {
    return this.savedCards;
  }

  public addToSavedCards(card: ICard, saveInDB: boolean = true): void {
    if(!this.isCardExitsInSaved(card)) {
      if(saveInDB) this.firebaseAuth.getUserUid().then(uid => this.cardService.setUserLike(card))
      this.savedCards.unshift(card);
      this.savedCardsSubject.next(this.savedCards);
    }
  }

  public removeFromSavedCards(cardToRemove: ICard, saveInDB: boolean = true): ICard {
    let cardRemoved: ICard;
    if(this.isCardExitsInSaved(cardToRemove)) {
      if(saveInDB) this.firebaseAuth.getUserUid().then(uid => this.cardService.removeUserLike(cardToRemove))
      const cardIndex = this.savedCards.findIndex((current: ICard)=> {
        return current.cardContentMobile === cardToRemove.cardContentMobile && current.cardTitle === cardToRemove?.cardTitle;
      })
      cardRemoved = this.savedCards.splice(cardIndex, 1)[0];
      this.removeUnlikedModelFromAllDraftCollections(cardRemoved.id);
      this.savedCardsSubject.next(this.savedCards);


    }
    return cardRemoved
  }

  public removeFromSavedCardsById(CardIdToRemove?: string) {
    let cardRemoved: ICard;
    if(this.isCardExitsInSavedById(CardIdToRemove)) {
      const cardIndex = this.savedCards.findIndex((current: ICard)=> {
        if(CardIdToRemove) return current.id === CardIdToRemove;
      })
      cardRemoved = this.savedCards.splice(cardIndex, 1)[0];
      this.savedCardsSubject.next(this.savedCards);
    }
    return cardRemoved
  }


  // LOGIC FOR COLLECTIONS;
  public isCollectionExitsInSaved(collectionOrId: ICardCollection | string): boolean {
    if(!collectionOrId) return

    let collectionId: string;

    // Determine if the input is an ICardCollection object or just a collectionId string
    if (typeof collectionOrId === 'string') {
      collectionId = collectionOrId;
    } else {
      collectionId = collectionOrId.collectionId;
    }

    // Find the collection by its ID
    const collectionIndex = this.savedCollections.findIndex((current: ICardCollection) => {
      return current.collectionId === collectionId;
    });

    return collectionIndex >= 0;
  }


  public getSavedCollections(): ICardCollection[] {
    return this.savedCollections;
  }

  public addToSavedCollections(collection: ICardCollection, saveInDB: boolean = true, shoulSetUpdatedData: boolean = true): void {
    if(saveInDB) this.firebaseAuth.getUserUid().then(uid => this.cardService.setUserLike(collection))
    // if(this.cardService.getCollectionFeedCardsById(collection.collectionId)) collection.collectionCards = this.cardService.getCollectionFeedCardsById(collection.collectionId);
    if(!this.isCollectionExitsInSaved(collection)) {
      if(shoulSetUpdatedData) collection.updated = new Date().toISOString();
      this.savedCollections.unshift(collection);
      // for debugging saved collections on the first screen;
      // this.savedCollections.push(collection);
      // if(this.savedCollections.length > 5) this.savedCollections.unshift(collection); this.savedCollections.unshift(collection);
      this.savedCollectionsSubject.next(this.savedCollections);
    }
  }

  public removeFromSavedCollections(collectionToRemove: ICardCollection, saveInDB: boolean = true): void {
    if(saveInDB) this.firebaseAuth.getUserUid().then(uid => this.cardService.removeUserLike(collectionToRemove));

    if(this.isCollectionExitsInSaved(collectionToRemove)) {
      const collectionIndex = this.savedCollections.findIndex((current: ICardCollection)=> {
        return current.collectionId === collectionToRemove.collectionId;
      })
      this.savedCollections.splice(collectionIndex, 1);
      this.savedCollectionsSubject.next(this.savedCollections);
    }
  }

  public addMockCollaborator(): ICollaborator {
    let collab;
    if(this.mockDataService.collaboratorsList.length > 0) {
      collab = this.mockDataService.collaboratorsList.splice(0,1);
      return collab[0];
    }
    return collab
  }

  public tryForFreeClicked(): void {
    this.cardService.activateTrialPostRequest().then((resp) => {
      this.firebaseAuth.currentUser.subscriptionStatus = SUBSCRIPTION_STATUS.TRIAL;
      // this.utilityFunctionsService.showImportantSnackBar('Free Trial Activated', 350);
    });
    // this.currentUser.isTryForFreeClicked = true;
  }

  // HELPER FUNCTIONS:
  public deleteCollectionFromDrafts(collection: ICardCollection): ICardCollection[] {
    if(collection.collectionId === DEFAULT_USER_COLLECTION_ID) {
      this.utilityFunctionsService.showErrorSnackBar('It is restricted to delete default collection',0);
      return
    }
    const delIndex = this.userDraftCollections.findIndex(col => col.collectionId === collection.collectionId);
    const deletedCollection = this.userDraftCollections.splice(delIndex, 1)[0];
    this.deletedCollections.push(deletedCollection);
    // this.userNotInCollectionCards.push(...deletedCollection.collectionCards);
    // this.addCardsToDefaultUserCollection(deletedCollection.collectionCards)
    return this.userDraftCollections;
  }

  // public deleteCardUnassignedToCollection(sourceCard: ICard): ICard[] {
  //   const targetCardIndex: number = this.userNotInCollectionCards.findIndex(thumbCard => thumbCard.cardTitle === sourceCard.cardTitle && thumbCard.cardContentMobile === sourceCard.cardContentMobile );
  //   const deletedCard = this.userNotInCollectionCards.splice(targetCardIndex, 1)[0];
  //   this.deletedCards.push(deletedCard);
  //   return this.userNotInCollectionCards
  // }

  public deleteCardInReview(sourceCard: ICard): ICard[] {
    const targetCardIndex: number = this.userReviewPublishRejectModels.findIndex(thumbCard => thumbCard.cardTitle === sourceCard.cardTitle && thumbCard.cardContentMobile === sourceCard.cardContentMobile );
    const deletedCard = this.userReviewPublishRejectModels.splice(targetCardIndex, 1)[0];
    this.deletedCards.push(deletedCard);
    return this.userReviewPublishRejectModels
  }

  public deleteCardFromPortfolio(sourceCard: ICard): ICard[] {
    switch (true) {
      case sourceCard.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED || sourceCard.purchaseStatus === CARD_PURCHASE_STATUS.REVIEW_PUBLISH_REJECT: {
        const targetCardIndex: number = this.uploadedCards.findIndex(thumbCard => thumbCard.cardTitle === sourceCard.cardTitle && thumbCard.cardContentMobile === sourceCard.cardContentMobile );
        const deletedCard = targetCardIndex >= 0 ? this.uploadedCards.splice(targetCardIndex, 1)[0] : undefined;
        if (deletedCard) {
          this.deletedCards.push(deletedCard);
        }

        // Updating collections after deletion card;
        this.userDraftCollections.forEach(col => {
            col.collectionCards = col.collectionCards.filter(card => card.id !== sourceCard.id);
        });
        this.reviewMetaByModelId.delete(sourceCard.id);

        return this.uploadedCards
      }
      case sourceCard.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED: {
        const reviewCardIndex: number = this.userReviewPublishRejectModels.findIndex(thumbCard => thumbCard.cardTitle === sourceCard.cardTitle && thumbCard.cardContentMobile === sourceCard.cardContentMobile);
        if (reviewCardIndex >= 0) {
          this.userReviewPublishRejectModels.splice(reviewCardIndex, 1);
        }

        const uploadedCardIndex: number = this.uploadedCards.findIndex(thumbCard => thumbCard.cardTitle === sourceCard.cardTitle && thumbCard.cardContentMobile === sourceCard.cardContentMobile);
        const deletedCard = uploadedCardIndex >= 0 ? this.uploadedCards.splice(uploadedCardIndex, 1)[0] : sourceCard;
        if (deletedCard) {
          this.deletedCards.push(deletedCard as ModelCardRenderedSelection);
        }

        this.userDraftCollections.forEach(col => {
            col.collectionCards = col.collectionCards.filter(card => card.id !== sourceCard.id);
        });
        this.reviewMetaByModelId.delete(sourceCard.id);

        return this.userReviewPublishRejectModels;
      }
      default:
        this.utilityFunctionsService.showErrorSnackBar('Error: no actions defined for this type of card in portfolio', 0);
        console.error('Error: no actions defined for this type of card in portfolio');
        break;
    }
  }

  public addCardToDeleteBuffer(sourceCard: ICard): void {
    this.toDeleteCardBuffer.push(sourceCard);
  }

  public cleanCardToDeleteBuffer(): void {
    this.toDeleteCardBuffer = [];
  }

  public deleteCardsFromBuffer(): void {
    this.toDeleteCardBuffer.forEach(card => {
      this.cardService.deleteModelPostRequest(card).then((resp) => {
      }).catch(error => this.utilityFunctionsService.showErrorSnackBar(`Error occured on delete ${card.cardTitle}: ${JSON.stringify(error.error)}`, 500));
    })
  }

  public async deleteCardsFromBufferAsync(): Promise<void> {
    if(this.toDeleteCardBuffer.length === 0) return;

    try {
      const deletePromises = this.toDeleteCardBuffer.map(card => {
        return this.cardService.deleteModelPostRequest(card);
      });

      await Promise.all(deletePromises);

      this.utilityFunctionsService.showSnackBar('All cards deleted successfully.', 500);
    } catch (error) {
      this.utilityFunctionsService.showErrorSnackBar(`Error occurred on delete: ${JSON.stringify(error.error)}`, 500);
    }
  }

  public createCollectionSnapshot(sourceSnapshotCollection: ICardCollection): ICardCollection {
    this.userCollectionSnapshot = JSON.parse(JSON.stringify(sourceSnapshotCollection))
    console.log('CREATED SNAP');
    return this.userCollectionSnapshot;
  }

  public restoreCollectionFromSnapshot(collectionToRestore: ICardCollection): ICardCollection {
    const targetIndx = this.userDraftCollections.findIndex(col => col.collectionId === collectionToRestore.collectionId);
    // this.userDraftCollections[targetIndx] = Object.assign(this.userCollectionSnapshot, collectionToRestore);
    this.userDraftCollections[targetIndx] = Object.assign({}, this.userCollectionSnapshot);

    console.log('SNAP RESTORED');
    return this.userDraftCollections[targetIndx];
  }

  public deleteCardFromCollection(sourceCard: ICard, sourceCollection: ICardCollection): ICardCollection {
    // Defensive guard: async UI callbacks can fire after state has changed.
    if (!sourceCollection?.collectionId || !sourceCard?.id) {
      console.error('Invalid args for deleteCardFromCollection', { sourceCard, sourceCollection });
      return sourceCollection;
    }

    const targetIndx = this.userDraftCollections.findIndex(col => col.collectionId === sourceCollection.collectionId);
    if (targetIndx < 0) {
      console.error('Collection not found while deleting card from collection:', sourceCollection.collectionId);
      return sourceCollection;
    }

    const targetCollection = this.userDraftCollections[targetIndx];
    const targetCardIndex = targetCollection.collectionCards.findIndex(card => card.id === sourceCard.id);

    if (targetCardIndex < 0) {
      console.error('Card not found in collection while deletion, ', sourceCard.cardTitle, sourceCard.cardContentMobile, sourceCollection.collectionId);
      return sourceCollection;
    }

    const deletedCard = targetCollection.collectionCards.splice(targetCardIndex, 1)[0];

    // Keep detached UI collection references in sync with service storage.
    // Without this, the screen can switch to a stale instance and lose visual status-based markers.
    if (sourceCollection !== targetCollection && Array.isArray(sourceCollection.collectionCards)) {
      sourceCollection.collectionCards = sourceCollection.collectionCards.filter(card => card.id !== sourceCard.id);
    }

    // REFACTOR/RETHINK AFTER: BECAUSE IT NOT APPLICABLE NOW FOR DELETE CARD FROM COLLECTION;
    deletedCard.parentCollectionId = sourceCollection.collectionId;
    this.deletedCards.push(deletedCard);
    // Return the same collection reference that UI is rendering when detached,
    // so filters and status-driven styling stay consistent immediately.
    return sourceCollection !== targetCollection ? sourceCollection : targetCollection;
  }

  public removeCollaboratorFromCollection(sourceCollection: ICardCollection, collaborator: ICollaborator): void {
    const indxToRemove = sourceCollection.collaborators.findIndex((col)=> col.id === collaborator.id);
    if(indxToRemove >= 0) sourceCollection.collaborators.splice(indxToRemove, 1);
  }

  public organizeAllCardsToDraftCollection(sourceCards: ICard[], targetCollection: ICardCollection): ICardCollection {
    console.log('SELECTED SOURCE CARD TO ORGANIZE ', sourceCards)
    const targetColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === targetCollection.collectionId);
    // Defensive guard: keep caller stable even if collection disappears mid-flow.
    if (targetColIndex < 0) {
      console.error('Target collection not found while organizing cards:', targetCollection?.collectionId);
      return targetCollection;
    }

    const targetDraftCollection = this.userDraftCollections[targetColIndex];
    // UI can hold a detached instance (mapped snapshot), not the mutable store reference.
    // We must update both to avoid filter mismatches right after adding models.
    const isDetachedSourceCollection = targetDraftCollection !== targetCollection;

    const existingIds = new Set([
      ...targetDraftCollection.collectionCards.map(card => card.id),
      ...targetCollection.collectionCards.map(card => card.id)
    ]);
    const addedIds = new Set<string>();

    const addToCollection = (cardToAdd: ICard): void => {
      if (!cardToAdd?.id || existingIds.has(cardToAdd.id) || addedIds.has(cardToAdd.id)) {
        return;
      }

      targetDraftCollection.collectionCards.unshift(cardToAdd);

      if (isDetachedSourceCollection) {
        targetCollection.collectionCards.unshift({ ...cardToAdd });
      }

      addedIds.add(cardToAdd.id);
    };

    const resolveCardForDraftCollection = (selectedCard: ICard): ICard | undefined => {
      if (!selectedCard?.id) return undefined;

      const savedCard = this.savedCards.find(card => card.id === selectedCard.id);
      if (savedCard) {
        // Saved cards inside a draft collection are represented as DRAFT_LIKED for local filters.
        return { ...savedCard, purchaseStatus: CARD_PURCHASE_STATUS.DRAFT_LIKED };
      }

      const purchasedCard = this.userPurchasedCards.find(card => card.id === selectedCard.id);
      if (purchasedCard) {
        return purchasedCard;
      }

      return this.uploadedCards.find(card => card.id === selectedCard.id);
    };

    // A selected model can appear in multiple source buckets depending on the current filter.
    // Resolve it once by id and add it once, otherwise add-from-library can duplicate cards.
    sourceCards.forEach((selectedCard) => {
      const cardToAdd = resolveCardForDraftCollection(selectedCard);
      if (cardToAdd) {
        addToCollection(cardToAdd);
      }
    });

    // Return detached source when needed, so the current screen keeps its consistent card statuses.
    return isDetachedSourceCollection ? targetCollection : targetDraftCollection;
  }

  public mutableOrganizeAllCardsToDraftCollectionOld(sourceCards: ICard[], targetCollection: ICardCollection): void {
    const targetColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === targetCollection.collectionId);

    const selectedSavedCards = sourceCards.filter((card) => {return this.savedCards.find((findcard) => {return findcard.cardContentMobile === card.cardContentMobile})});
    const selectedUserPurchasedCards = sourceCards.filter((card) => {return this.userPurchasedCards.find((findcard) => {return findcard.cardContentMobile === card.cardContentMobile})});
    const selectedUploadedCards = sourceCards.filter((card) => {return this.uploadedCards.find((findcard) => {return findcard.cardContentMobile === card.cardContentMobile})});

    if(selectedSavedCards) {
      selectedSavedCards.forEach(sCard => {
        const sourceCardIndex: number = this.savedCards.findIndex(card => card.cardTitle === sCard.cardTitle && card.cardContentMobile === sCard.cardContentMobile );
        const cardToMoveDetached = this.savedCards.splice(sourceCardIndex,1);
        cardToMoveDetached[0].purchaseStatus = CARD_PURCHASE_STATUS.DRAFT_LIKED;
        this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);
      })
    }

    if(selectedUserPurchasedCards) {
      selectedUserPurchasedCards.forEach(sCard => {
        const sourceCardIndex: number = this.userPurchasedCards.findIndex(card => card.cardTitle === sCard.cardTitle && card.cardContentMobile === sCard.cardContentMobile );
        const cardToMoveDetached = this.userPurchasedCards.splice(sourceCardIndex,1);
        this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);
      })
    }

    if(selectedUploadedCards) {
      selectedUploadedCards.forEach(sCard => {
        const sourceCardIndex: number = this.uploadedCards.findIndex(card => card.cardTitle === sCard.cardTitle && card.cardContentMobile === sCard.cardContentMobile );
        const cardToMoveDetached = this.uploadedCards.splice(sourceCardIndex,1);
        this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);
      })
    }
  }

  public moveCardFromPurchasedToSelectedDraftCollection(sourceCards: ICard[], targetCollection: ICardCollection) {

    sourceCards.forEach(sourceCard => {
      const sourceCardIndex: number = this.userPurchasedCards.findIndex(card => card.cardTitle === sourceCard.cardTitle && card.cardContentMobile === sourceCard.cardContentMobile );
      const targetColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === targetCollection.collectionId);
      const cardToMoveDetached = this.userPurchasedCards.splice(sourceCardIndex,1);

      const purchasedCollectionIndex = this.userPurchasedCollections.findIndex(purCol => purCol.collectionId === sourceCard.parentCollectionId);
      const purchasedCollectionCardIndex = this.userPurchasedCollections[purchasedCollectionIndex].collectionCards.findIndex(card => card.cardTitle === sourceCard.cardTitle && card.cardContentMobile === sourceCard.cardContentMobile );
      this.userPurchasedCollections[purchasedCollectionIndex].collectionCards.splice(purchasedCollectionCardIndex, 1);
      // eslint-disable-next-line max-len
      if(this.userPurchasedCollections[purchasedCollectionIndex].collectionCards.filter((card)=>{return card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED}).length === 0) this.userPurchasedCollections.splice(purchasedCollectionIndex, 1);

      this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);
    });
  }

  // public moveUnassignedCardToSelectedDraftCollection(sourceCard: ICard, targetCollection: ICardCollection) {
  //   console.log('MOVE')
  //   // const sourceCardIndex: number = this.defaultUserCollection.collectionCards.findIndex(card => card.cardTitle === sourceCard.cardTitle && card.cardContentMobile === sourceCard.cardContentMobile );
  //   // const targetColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === targetCollection.collectionId);
  //   // const cardToMoveDetached = this.defaultUserCollection.collectionCards.splice(sourceCardIndex,1);
  //   // this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);
  // }

  public moveSelectedCardBetweenCollectionDrafts(sourceCard: ICard, sourceCollection: ICardCollection, targetCollection: ICardCollection): ICardCollection {
    const sourceColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === sourceCollection.collectionId);
    const sourceCardIndex: number = this.userDraftCollections[sourceColIndex].collectionCards.findIndex(card => card.cardTitle === sourceCard.cardTitle && card.cardContentMobile === sourceCard.cardContentMobile );
    const targetColIndex: number = this.userDraftCollections.findIndex(col => col.collectionId === targetCollection.collectionId);

    const cardToMoveDetached = this.userDraftCollections[sourceColIndex].collectionCards.splice(sourceCardIndex,1);
    this.userDraftCollections[targetColIndex].collectionCards.unshift(cardToMoveDetached[0]);

    return this.userDraftCollections[sourceColIndex];

  }

  // NOT IN COLLECTION FUNCs

  // public updateNotInCollectionCard(updateCard: ModelCardRendered): void {
  //   if(updateCard === undefined) return;

  //   const cardToUpdateIndex = this.defaultUserCollection.collectionCards.findIndex(card  => {
  //     return card.id === updateCard.id;
  //   })
  //   // if(cardToUpdateIndex >= 0) {
  //   //   this.defaultUserCollection.collectionCards[cardToUpdateIndex] = updateCard;
  //   // } else {
  //   //   this.defaultUserCollection.collectionCards.push(updateCard);
  //   // }

  //   this.defaultUserCollection.collectionCards[0] = updateCard;
  // }

  public addCardsToDefaultUserCollection(sourceCards: ICard[]): void {

    const selectedUserPurchasedCards = sourceCards.filter((card) => {return card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED});
    const selectedUploadedCards = sourceCards.filter((card) => {return card.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED});

    this.userPurchasedCards.push(...this.userPurchasedCards, ...selectedUserPurchasedCards);
    this.uploadedCards.push(...this.userPurchasedCards, ...selectedUploadedCards);

  }

  // public getDefaultCollectionCards(): ModelCardRenderedSelection[] {
  //   return this.defaultUserCollection.collectionCards
  // }

  // USE CardID instead of poster data!!!!
  public isCardPurchasedCheckById(idToCheck: string): boolean {
    const indx = this.userPurchasedCards.findIndex(card => card.id === idToCheck)
    return indx > -1 ? true : false;
  }


  public purchaseSingleCard(cardTopPurchase: ICard ) {
    cardTopPurchase.purchaseStatus = CARD_PURCHASE_STATUS.PURCHASED;
    this.userPurchasedCards.push(cardTopPurchase);
    if(cardTopPurchase.parentCollectionId) {
      const parentCollectionIndex = this.userPurchasedCollections.findIndex(col => col.collectionId === cardTopPurchase.parentCollectionId);
      if(parentCollectionIndex >= 0) {
        const purchasedCardIndex = this.userPurchasedCards.findIndex(card => card.id === cardTopPurchase.id );
        const clonedPurchasedCard = JSON.parse(JSON.stringify(this.userPurchasedCards[purchasedCardIndex]));
        this.userPurchasedCollections[parentCollectionIndex].collectionCards.unshift(clonedPurchasedCard);
      }
      if(parentCollectionIndex === -1) {
        const baseCollection = this.cardService.feedCollectionCardsSource.find(col => col.collectionId === cardTopPurchase.parentCollectionId);
        if(baseCollection) {
          const clonedBasedCollection: ICardCollection = JSON.parse(JSON.stringify(baseCollection));
          clonedBasedCollection.purchaseDetails = {allCardsQuantity: undefined}
          clonedBasedCollection.purchaseDetails.allCardsQuantity = clonedBasedCollection.collectionCards.length;
          clonedBasedCollection.collectionCards = clonedBasedCollection.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED);
          const purchasedCardIndex = this.userPurchasedCards.findIndex(card => card.id === cardTopPurchase.id );
          const clonedPurchasedCard = JSON.parse(JSON.stringify(this.userPurchasedCards[purchasedCardIndex]));
          clonedBasedCollection.collectionCards.unshift(clonedPurchasedCard);
          const idColIndex = this.userPurchasedCollections.findIndex(purCol => purCol.collectionId === clonedBasedCollection.collectionId);
          if(idColIndex === -1) this.userPurchasedCollections.push(clonedBasedCollection);
          if(idColIndex >= 0) {
            this.userPurchasedCollections[idColIndex] = clonedBasedCollection
          }
        } else console.error('Parent collection not found');

      }
    } else {
      console.error('Card has no parent collection');
    }
  }

  public purchaseCards(cardsToPurchase: ModelCardRenderedSelection[], baseCollection: ICardCollection) {
      baseCollection.collectionCards.forEach((card) => {
        if(cardsToPurchase.filter(cardToPurc => cardToPurc.cardPosterMobile === card.cardPosterMobile).length > 0) {
          card.purchaseStatus = CARD_PURCHASE_STATUS.PURCHASED;
          this.userPurchasedCards.push(card);
        }
      })

      const clonedBasedCollection: ICardCollection = JSON.parse(JSON.stringify(baseCollection));
      clonedBasedCollection.purchaseDetails = {allCardsQuantity: undefined}
      clonedBasedCollection.purchaseDetails.allCardsQuantity = clonedBasedCollection.collectionCards.length;
      clonedBasedCollection.collectionCards = clonedBasedCollection.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED);
      const idColIndex = this.userPurchasedCollections.findIndex(purCol => purCol.collectionId === clonedBasedCollection.collectionId);
      if(idColIndex === -1) this.userPurchasedCollections.push(clonedBasedCollection);
      if(idColIndex >= 0) {
        this.userPurchasedCollections[idColIndex] = clonedBasedCollection
      }
  }

  public async sendModelForReview(model: ICard): Promise<boolean> {
    if (!model?.id) {
      return false;
    }

    const uploadedCard = this.uploadedCards.find((card) => card.id === model.id);

    let response;
    try {
      response = await this.cardService.sendToReviewModelPostRequest(model);
    } catch (error) {
      this.utilityFunctionsService.showErrorSnackBar(`Error occurred on publishing: ${error}`, 500);
      return false;
    }

    this.setModelReviewState(model.id, CARD_PURCHASE_STATUS.IN_REVIEW, model, uploadedCard);

    if (response?.review_model_id) {
      model.publicModelId = response.review_model_id;
      if (uploadedCard) {
        uploadedCard.publicModelId = response.review_model_id;
      }
    }

    const reviewCreatedAt = response?.review_created_at || new Date().toISOString();
    const reviewMetaUpdate: Partial<IReviewCardMeta> = {
      reviewCreatedAt,
      rejectionViewed: false,
      rejectionViewedAt: null,
    };
    if (response?.review_id) {
      reviewMetaUpdate.reviewId = response.review_id;
    }
    this.upsertReviewMeta(model.id, reviewMetaUpdate);
    this.upsertInReviewCard(model, undefined, reviewCreatedAt);
    this.utilityFunctionsService.showImportantSnackBar('Model sent for review', 300);
    return true;
  }

  public async sendModelsForReview(models: ICard[]): Promise<boolean> {
    for (const model of models) {
      if (!model?.id) {
        continue;
      }

      const uploadedCard = this.uploadedCards.find((card) => card.id === model.id);

      let response;
      try {
        response = await this.cardService.sendToReviewModelPostRequest(model);
      } catch (error) {
        this.utilityFunctionsService.showErrorSnackBar(`Error occurred on publishing: ${error}`, 500);
        return false;
      }

      this.setModelReviewState(model.id, CARD_PURCHASE_STATUS.IN_REVIEW, model, uploadedCard);

      if (response?.review_model_id) {
        model.publicModelId = response.review_model_id;
        if (uploadedCard) {
          uploadedCard.publicModelId = response.review_model_id;
        }
      }

      const reviewCreatedAt = response?.review_created_at || new Date().toISOString();
      const reviewMetaUpdate: Partial<IReviewCardMeta> = {
        reviewCreatedAt,
        rejectionViewed: false,
        rejectionViewedAt: null,
      };
      if (response?.review_id) {
        reviewMetaUpdate.reviewId = response.review_id;
      }
      this.upsertReviewMeta(model.id, reviewMetaUpdate);
      this.upsertInReviewCard(model, undefined, reviewCreatedAt);
    }

    return true;
  }

  public async markRejectedCardViewed(card: ICard): Promise<boolean> {
    if (!card?.id) {
      return false;
    }

    const reviewId = this.resolveReviewIdForCard(card);
    if (!reviewId) {
      this.utilityFunctionsService.showErrorSnackBar('Unable to mark rejection as viewed: review_id is missing.', 500);
      return false;
    }

    let response: any;
    try {
      response = await this.cardService.markRejectionViewed(reviewId);
    } catch (error) {
      console.warn('Failed to mark rejection as viewed', error);
      return false;
    }

    const rejectionViewedAt = response?.rejection_viewed_at || new Date().toISOString();
    this.applyRejectionViewedState(card.id, reviewId, rejectionViewedAt);
    return true;
  }

  private setModelReviewState(
    modelId: string,
    status: CARD_PURCHASE_STATUS,
    model?: ICard,
    uploadedCard?: ICard,
    modifiedDate?: string,
  ): void {
    if (model) {
      model.purchaseStatus = status;
      if (modifiedDate) {
        model.modifiedDate = modifiedDate;
      }
    }

    if (uploadedCard) {
      uploadedCard.purchaseStatus = status;
      if (modifiedDate) {
        uploadedCard.modifiedDate = modifiedDate;
      }
    } else {
      const uploadedById = this.uploadedCards.find((card) => card.id === modelId);
      if (uploadedById) {
        uploadedById.purchaseStatus = status;
        if (modifiedDate) {
          uploadedById.modifiedDate = modifiedDate;
        }
      }
    }

    this.userDraftCollections.forEach((collection) => {
      collection.collectionCards.forEach((collectionCard) => {
        if (collectionCard.id === modelId) {
          collectionCard.purchaseStatus = status;
          if (modifiedDate) {
            collectionCard.modifiedDate = modifiedDate;
          }
        }
      });
    });
  }

  private upsertInReviewCard(model: ICard, modifiedDate?: string, reviewCreatedAt?: string): void {
    const existingReviewCard = this.userReviewPublishRejectModels.find((card) => card.id === model.id) as ICardExtended;
    if (existingReviewCard) {
      existingReviewCard.purchaseStatus = CARD_PURCHASE_STATUS.IN_REVIEW;
      if (modifiedDate) {
        existingReviewCard.modifiedDate = modifiedDate;
      }
      if (reviewCreatedAt) {
        existingReviewCard.reviewCreatedAt = reviewCreatedAt;
      }
      if (model.publicModelId) {
        existingReviewCard.publicModelId = model.publicModelId;
      }
      return;
    }

    const inReviewCard: ICardExtended = JSON.parse(JSON.stringify(model));
    inReviewCard.purchaseStatus = CARD_PURCHASE_STATUS.IN_REVIEW;
    if (modifiedDate) {
      inReviewCard.modifiedDate = modifiedDate;
    }
    if (reviewCreatedAt) {
      inReviewCard.reviewCreatedAt = reviewCreatedAt;
    }
    this.userReviewPublishRejectModels.unshift(inReviewCard);
  }

  private resolveReviewIdForCard(card: ICard): string {
    const reviewMeta = this.getReviewMeta(card?.id);
    if (reviewMeta?.reviewId) {
      return reviewMeta.reviewId;
    }

    const reviewCard = this.userReviewPublishRejectModels.find((item) => item.id === card.id);
    if (reviewCard?.reviewId) {
      return reviewCard.reviewId;
    }

    const uploadedCard = this.uploadedCards.find((item) => item.id === card.id) as ICardExtended | undefined;
    if (uploadedCard?.reviewId) {
      return uploadedCard.reviewId;
    }

    for (const collection of this.userDraftCollections) {
      const collectionCard = collection?.collectionCards?.find((item) => item.id === card.id) as ICardExtended | undefined;
      if (collectionCard?.reviewId) {
        return collectionCard.reviewId;
      }
    }

    return '';
  }

  private applyRejectionViewedState(modelId: string, reviewId: string, rejectionViewedAt: string): void {
    this.upsertReviewMeta(modelId, {
      reviewId,
      rejectionViewed: true,
      rejectionViewedAt,
    });
  }

  private upsertReviewMeta(modelId: string, reviewMeta: Partial<IReviewCardMeta>): void {
    if (!modelId) {
      return;
    }

    const currentMeta = this.reviewMetaByModelId.get(modelId) || {};
    const nextMeta: IReviewCardMeta = { ...currentMeta };

    if (reviewMeta.reviewId !== undefined) {
      nextMeta.reviewId = reviewMeta.reviewId;
    }
    if (reviewMeta.reviewCreatedAt !== undefined) {
      nextMeta.reviewCreatedAt = reviewMeta.reviewCreatedAt;
    }
    if (reviewMeta.rejectionViewed !== undefined) {
      nextMeta.rejectionViewed = reviewMeta.rejectionViewed;
    }
    if (reviewMeta.rejectionViewedAt !== undefined) {
      nextMeta.rejectionViewedAt = reviewMeta.rejectionViewedAt;
    }

    this.reviewMetaByModelId.set(modelId, nextMeta);
  }

  private getReviewMeta(modelId: string): IReviewCardMeta | undefined {
    if (!modelId) {
      return undefined;
    }

    return this.reviewMetaByModelId.get(modelId);
  }



  public cancelModelPublishing(cardToCancel: ICard): void {
    const indxToDel = this.userReviewPublishRejectModels.findIndex(card => card.id === cardToCancel.id);
    this.userReviewPublishRejectModels.splice(indxToDel,1);

    const foundCard = this.uploadedCards.find(card => card.id === cardToCancel.id);
    if (foundCard) {
      foundCard.purchaseStatus = CARD_PURCHASE_STATUS.UPLOADED;
    } else {
      console.error('Card not found in uploaded models; Probably, it was deleteted from uploaded models');
    }

    // COMMENTED DUE TO CHANGED LOGIC;
    // const colInd = this.userDraftCollections.findIndex(col => col.collectionId === cardToCancel.parentCollectionId);
    // if(colInd > - 1) {
    //   this.userDraftCollections[colInd].collectionCards.find(cardToFind => cardToFind.cardContentMobile === cardToCancel.cardContentMobile).purchaseStatus = CARD_PURCHASE_STATUS.UPLOADED;
    //   this.utilityFunctionsService.showSnackBar('Publish canceled', 0);
    // }
  }

  public getAvailableFiltersForCollection(col: ICardCollection): INavpanelAction[] {
      const filterNavPanelItems = [];
      const isAnyCardLiked = col.collectionCards.filter(card => this.isCardExitsInSaved(card) || card.purchaseStatus === CARD_PURCHASE_STATUS.DRAFT_LIKED).length > 0;
      const isAnyCardUploaded = col.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.UPLOADED).length > 0;
      const isAnyCardPurchased = col.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.PURCHASED).length > 0;
      const isAnyCardReviewing = col.collectionCards.filter(card => card.purchaseStatus === CARD_PURCHASE_STATUS.IN_REVIEW || card.purchaseStatus === CARD_PURCHASE_STATUS.PUBLISHED ||
        card.purchaseStatus === CARD_PURCHASE_STATUS.REJECTED).length > 0;

      filterNavPanelItems.push({actionName: 'All Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_ALL_MODELS })

      if(isAnyCardLiked) {
        filterNavPanelItems.push({actionName: 'Saved Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_SAVED_MODELS },)
      }
      if(isAnyCardUploaded || isAnyCardReviewing) {
        filterNavPanelItems.push({actionName: 'By You Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_UPLOADED_MODELS },)
      }
      if(isAnyCardPurchased) {
        filterNavPanelItems.push({actionName: 'Purchased Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_PURCHASE_MODELS },)
      }
      // if(isAnyCardReviewing) {
      //   filterNavPanelItems.push({actionName: 'Publishing Models', actionType: NAVPANEL_ACTION_TYPE.FILTER_REVIEW_MODELS },)
      // }
      return filterNavPanelItems
  }

  public generateUploadCard(customId: string): ICard {
    const generatedCard = this.mockDataService.generateRandomCard();
    generatedCard.id = customId;
    this.uploadedCards.push(generatedCard);
    return generatedCard
  }

  public generateCollectionFromCard(card: ModelCardRendered): ICardCollection {
    return {
      collectionId: card.parentCollectionId ? card.parentCollectionId : card.id,
      collectionSharingId: card.cardSharingId,
      collectionTitle: card.cardTitle,
      collectionDescription: card.cardDescription,
      collectionPosterWeb: card.cardPosterWeb,
      collectionContentMobile: card[CORRECT_APP_CONTENT],
      collectionAuthor: card.cardAuthor,
      collectionPosterMobile: card[CORRECT_APP_POSTER],
      collectionCards: [],
      created: new Date().toDateString(),
      updated: new Date().toDateString(),
    }
  }

  public getNewCollectionDefaultName(): string {
    return `Collection ${this.userDraftCollections.length + 1}`;
  }

  public getNewUploadFileDefaultName(): string {
    const commonLength = this.uploadedCards.length + this.uploadService.uploadModels.length + 1;
    return `Model ${commonLength + 1}`;
  }

  public getMockPurchasedCards(): string[] {
    return this.temporaryPurchaedCardsMock;
  }

  public addToMockPurchasedCards(id: string): void {
    this.temporaryPurchaedCardsMock.push(id);
  }

  public getProfileNavPanelItems(): INavpanelAction[] {
    let navpanelItems
    try {
      const subscribeItem: INavpanelAction = { actionName: 'Susbcribe 3DWay Basic Plan', actionType: NAVPANEL_ACTION_TYPE.TEST_BUY_SUBSCRIPTION };
      if(this.isUserSubscribed) subscribeItem.actionName = '⭐️ Subscribed for 3DWay Basic Plan';
      if (environment.production) {
        navpanelItems = [
          { actionName: 'Sign Out', actionType: NAVPANEL_ACTION_TYPE.SIGN_OUT }
        ]
      } else {
        navpanelItems = [
          { actionName: 'Beta Settings', actionType: NAVPANEL_ACTION_TYPE.SETTINGS },
          { actionName: 'Sign Out', actionType: NAVPANEL_ACTION_TYPE.SIGN_OUT },
        ]
        if(this.settingService.additionalSettingsEnabled) {
           navpanelItems.splice(1, 0, subscribeItem);
        }
      }
      return navpanelItems

    } catch (error) {
      this.utilityFunctionsService.rollbarError(error);
      navpanelItems = [
        { actionName: 'Sign Out', actionType: NAVPANEL_ACTION_TYPE.SIGN_OUT }
      ]
      return navpanelItems
    }

  }


  public getTopNavPanelMenuItems(): INavpanelAction[] {
    let navpanelItems
    const subscribeItem: INavpanelAction = { actionName: 'Susbcribe 3DWay Basic Plan', actionType: NAVPANEL_ACTION_TYPE.TEST_BUY_SUBSCRIPTION };

    if(this.isUserSubscribed) subscribeItem.actionName = '⭐️ Subscribed for 3DWay Basic Plan';

    if (environment.production) {
      navpanelItems = [
        // { actionName: 'Purchases', actionType: NAVPANEL_ACTION_TYPE.PURCHASES },
        // { actionName: 'Test buy consumable', actionType: NAVPANEL_ACTION_TYPE.TEST_BUY_CONSUMABLE },
        { actionName: 'Contact 3DWay', actionType: NAVPANEL_ACTION_TYPE.CONTACT_US },
        // { actionName: 'Link Payments', actionType: NAVPANEL_ACTION_TYPE.LINK_PAYMENTS },
        // { actionName: 'Recently Deleted', actionType: NAVPANEL_ACTION_TYPE.RECENTLY_DELETED },
        { actionName: 'View Account', actionType: NAVPANEL_ACTION_TYPE.VIEW_ACCOUNT },
      ]
    } else {
      navpanelItems = [
        // { actionName: 'Purchases', actionType: NAVPANEL_ACTION_TYPE.PURCHASES },

        { actionName: 'Beta Settings', actionType: NAVPANEL_ACTION_TYPE.SETTINGS },
        // { actionName: 'Test buy consumable', actionType: NAVPANEL_ACTION_TYPE.TEST_BUY_CONSUMABLE },

        // { actionName: 'Show Subscribe Splash Screen', actionType: NAVPANEL_ACTION_TYPE.SHOW_SUBSCRIBE },
        { actionName: 'Contact 3DWay', actionType: NAVPANEL_ACTION_TYPE.CONTACT_US },
        { actionName: 'Link Payments', actionType: NAVPANEL_ACTION_TYPE.LINK_PAYMENTS },
        // { actionName: 'Recently Deleted', actionType: NAVPANEL_ACTION_TYPE.RECENTLY_DELETED },
        { actionName: 'View Account', actionType: NAVPANEL_ACTION_TYPE.VIEW_ACCOUNT },
      ]
      if(this.settingService.additionalSettingsEnabled) {
         navpanelItems.splice(1, 0, subscribeItem);
      }
    }
    return navpanelItems
  }

  private incrementProgress() {
    const start = this.recievingModelsRespBackendProgress;
    const end = 95;
    const duration = 1500; // 1.5 seconds
    const steps = 60; // Number of increments
    const increment = (end - start) / steps;
    const intervalTime = duration / steps;

    let currentStep = 0;

    const interval = setInterval(() => {
      if (currentStep < steps) {
        this.recievingModelsRespBackendProgress += increment;
        currentStep++;
      } else {
        this.recievingModelsRespBackendProgress = end; // Ensure it ends exactly at 95
        clearInterval(interval);
      }
    }, intervalTime);
  }

  public cleanAllUserData(): void {
    this.userDraftCollections = [];
    this.userPurchasedCollections = [];
    this.userPurchasedCards = [];
    this.uploadedCards = [];
    this.userReviewPublishRejectModels = [];
    this.reviewMetaByModelId.clear();
    this.savedCards = [];
    this.savedCollections = [];
    // Clean upload service data;
    this.uploadService.firebaseUploadingItem = [];
    this.uploadService.uploadModels = [];
  }

}
